import { usePermissions } from '@/contexts/auth';
import { useFlagHeldOpen } from '@/hooks/heldOpenFlags';
import { usePostHogFeatureFlag } from '@/hooks/usePostHogFeatureFlag';
import { dataSourcesPath } from '@/routes/shared/ProviderConfig/dataSourcesPath';

/**
 * The site's data sources page, for those who may open it: OptoScale admins with the flag on,
 * for now. Null hides every link to it.
 */
export function useDataSourcesHref(clientId: number, locationId: number): string | null {
    const { isOptoScaleAdmin } = usePermissions();
    const { enabled } = usePostHogFeatureFlag('provider-config-ui');
    // While the page is open its own links stay, as the page does (useFeatureFlagGate).
    const heldOpen = useFlagHeldOpen('provider-config-ui');
    return (enabled || heldOpen) && isOptoScaleAdmin ? dataSourcesPath(clientId, locationId) : null;
}
